import { heroStats } from "@/mocks/homeData";

const heroTags = [
  "#内娱动态",
  "#职场黑幕",
  "#品牌翻车",
  "#带货打假",
  "#匿名投稿",
  "#二手避坑",
];

export default function HeroSection() {
  return (
    <section id="top" className="relative w-full overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=dark%20moody%20abstract%20editorial%20background%2C%20deep%20charcoal%20texture%20with%20warm%20amber%20and%20orange%20glow%2C%20glowing%20light%20streaks%20and%20floating%20paper%20documents%20with%20digital%20data%20particles%2C%20cinematic%20investigative%20atmosphere%2C%20dramatic%20contrast%2C%20no%20text%2C%20no%20logo%2C%20wide%20composition&width=1600&height=900&seq=hl-hero-01&orientation=landscape"
        alt="黑料官方社区讨论氛围主视觉背景"
        title="黑料官方 社区讨论 官方入口"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/60 to-black/80"></div>

      <div className="relative z-10 w-full px-4 md:px-8 pt-28 md:pt-40 pb-20 md:pb-28">
        <div className="max-w-5xl mx-auto text-center">
          <div className="inline-flex items-center gap-2 rounded-full border border-white/25 bg-white/10 px-3.5 py-1.5 text-xs md:text-sm text-background-100 backdrop-blur">
            <span className="w-2 h-2 rounded-full bg-accent-400"></span>
            <span>社区热榜 · 今日已更新 128 条线索</span>
          </div>

          <h2 className="mt-6 font-heading text-3xl sm:text-4xl md:text-6xl font-black tracking-tight text-background-50 leading-[1.15]">
            找到黑料官方
            <br className="sm:hidden" />
            <span className="text-primary-300"> 最快的那一个入口</span>
          </h2>

          <p className="mt-5 md:mt-6 mx-auto max-w-3xl text-sm md:text-lg leading-relaxed text-background-100">
            这里整理了黑料官方联系方式、客服邮箱与官方直达渠道。无论你是有料要曝，
            还是想找黑料官方客服咨询，从这里一步直达，不用再到处翻找。
          </p>

          <div className="mt-8 md:mt-10 flex flex-col sm:flex-row items-stretch sm:items-center justify-center gap-3">
            <a
              href="#channels"
              className="inline-flex items-center justify-center gap-2 bg-primary-500 hover:bg-primary-600 text-background-50 text-sm md:text-base font-medium px-6 md:px-8 py-3.5 md:py-4 rounded-md whitespace-nowrap transition-colors cursor-pointer"
            >
              <i className="ri-rocket-2-line"></i>
              <span>直达官方入口</span>
            </a>
            <a
              href="#contact"
              className="inline-flex items-center justify-center gap-2 border border-white/30 bg-white/10 hover:bg-white/20 text-background-50 text-sm md:text-base font-medium px-6 md:px-8 py-3.5 md:py-4 rounded-md backdrop-blur whitespace-nowrap transition-colors cursor-pointer"
            >
              <i className="ri-mail-send-line"></i>
              <span>查看客服邮箱</span>
            </a>
          </div>

          <div className="mt-8 flex flex-wrap items-center justify-center gap-2">
            {heroTags.map((tag) => (
              <span
                key={tag}
                className="rounded-full border border-white/20 bg-white/5 px-3 py-1 text-xs md:text-sm text-background-100 hover:border-accent-400 hover:text-accent-300 transition-colors cursor-pointer"
              >
                {tag}
              </span>
            ))}
          </div>
        </div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-8 pb-10 md:pb-14">
        <div className="max-w-5xl mx-auto grid grid-cols-2 md:grid-cols-4 gap-px overflow-hidden rounded-lg border border-white/15 bg-white/10 backdrop-blur">
          {heroStats.map((stat) => (
            <div key={stat.label} className="bg-black/25 px-4 py-5 md:px-6 md:py-7 text-center">
              <div className="font-heading text-2xl md:text-3xl font-black text-background-50">
                {stat.value}
                <span className="ml-1 text-xs md:text-sm font-medium text-primary-300">{stat.unit}</span>
              </div>
              <div className="mt-1.5 text-xs md:text-sm text-background-200">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}